import React, { Fragment, useEffect, useState } from 'react';
import RankedBarChart from './RankedBarChart';
import { Card, CardBody, CardHeader, Col } from "reactstrap";
import { H5 } from '../../../../AbstractElements';
import { Dropdown, DropdownButton } from 'react-bootstrap';
import axios from 'axios';
import config from '../../../../config';
import { useTranslation } from 'react-i18next';

const Top5Categories = ({ year, month, propertyMallCode, className }) => {
    const { t } = useTranslation();
    const [topFiveData, setTopFiveData] = useState({
        sales: [],
        growth: []
    });
    const [chartData, setChartData] = useState({});
    const [title, setTitle] = useState('By Sales');

    const concessionaire_id = localStorage.getItem("concessionaireId");
    const property_id = localStorage.getItem("propertyAccess");
    const token = localStorage.getItem("sessiontoken");

    const configheader = {
        headers: {
            Authorization: `${token}`
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            const apiUrl = year || propertyMallCode || month ? 'dashboardfiltered' : 'dashboard';
            const apiData = {
                concessionaire_id,
                property_id,
                year,
                propertyMallCode,
                month
            };

            try {
                if (apiUrl !== '') {
                    const [salesResponse, growthResponse] = await Promise.all([
                        axios.post(`${config.hostname}/${apiUrl}/topfivecategory`, apiData, configheader),
                        axios.post(`${config.hostname}/${apiUrl}/topfivecategorybygrowth`, apiData, configheader)
                    ]);

                    setTopFiveData({
                        sales: salesResponse.data.topFiveSubcategories,
                        growth: growthResponse.data.topFiveSubcategories
                    });

                    // Initialize chart data based on fetched data
                    updateChartData('BySales', salesResponse.data.topFiveSubcategories);
                }
            } catch (error) {
                console.error(error);
            }
        };

        fetchData();
    }, [year, month, propertyMallCode, concessionaire_id, property_id, token]); // Ensures fetch only on change

    const updateChartData = (type, data) => {
        const items = (data || []).map((category) => ({
            label: category.subcategoryName,
            value: type === 'BySales' ? category.totalSales / 1000000 : category.growthPercentage,
        }));

        setChartData({
            items,
            suffix: type === 'BySales' ? 'M' : '%',
        });
        setTitle(type === 'BySales' ? 'By Sales' : 'By Growth');
    };

    const handleOptionSelect = (option) => {
        updateChartData(option === 'BySales' ? 'BySales' : 'ByGrowth', option === 'BySales' ? topFiveData.sales : topFiveData.growth);
    };

    return (
        <Fragment>
            <Col sm='12' xl='6' className={className}>
                <Card>
                    <CardHeader>
                        <div>
                            <H5> <div style={{ display: 'flex', alignItems: 'center' }}>
                                <div>{t('Top 5 Categories')}</div>
                                <div style={{ fontSize: '0.7em', color: '#777', marginLeft: '10px' }}>{t(title)}</div>
                                {title === 'By Sales' ? (
                                    <div style={{ fontSize: '0.5em', color: '#777', marginLeft: '10px' }}>{t('(values in millions)')}</div>
                                ) :
                                    <div style={{ fontSize: '0.5em', color: '#777', marginLeft: '10px' }}>{t('(values in percentage)')}</div>
                                }
                            </div></H5>
                            <DropdownButton id="dropdown-basic-button" title={t('Options')} variant="dark">
                                <Dropdown.Item onClick={() => handleOptionSelect('BySales')}>{t('By Sales')}</Dropdown.Item>
                                <Dropdown.Item onClick={() => handleOptionSelect('ByGrowth')}>{t('By Growth')}</Dropdown.Item>
                            </DropdownButton>
                        </div>
                    </CardHeader>
                    <CardBody>
                        {chartData.items && chartData.items.length > 0 ? (
                            <RankedBarChart items={chartData.items} suffix={chartData.suffix} height={360} />
                        ) : (
                            <div>{t('No data...')}</div>
                        )}
                    </CardBody>
                </Card>
            </Col>
        </Fragment>
    );
}

export default Top5Categories;